import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { LinkProps } from '@atlassian/jira-router';
import TableCellLink from '../../table-cell-link';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledLinkStylesWrapper = styled.span({
	'& > a': {
		color: token('color.text', colors.N800),
		display: '-webkit-box',
		WebkitLineClamp: 5,
		WebkitBoxOrient: 'vertical',
		lineHeight: '24px',
		overflow: 'hidden',
	},
	'& > a:hover, & > a:focus': {
		color: `${token('color.text', colors.N800)} !important`,
	},
});

export const StyledLink = (props: LinkProps) => (
	<StyledLinkStylesWrapper>
		<TableCellLink {...props} />
	</StyledLinkStylesWrapper>
);
